/* eslint-disable camelcase */
import React from "react"
import { useSelector } from "react-redux"

import {
    NO_DANGEROUS_FAILURE,
    NO_SAFE_FAILURE,
    NO_ARCHITECTURAL_CONSTRAINTS,
    IEC_61508_2010,
    IEC_61508_1998,
    IEC_61511_2016,
    IEC_61511_2003,
    ISA_TR84_2002,
    ISA_TR84_2022,
    VDI_VDE_2180_2019,

    ARCHITECTURE_1oo1,
    ARCHITECTURE_1oo2,
    ARCHITECTURE_1oo2D,
    ARCHITECTURE_1oo3,
    ARCHITECTURE_2oo2,
    ARCHITECTURE_2oo3,
    ARCHITECTURE_3oo3,

    YES, NO,
} from "const"
import { SilCalculationMethod } from "client/utils"
import { StoreType } from "client/store"
import {
    FormGroup,
    Label,
    LabelValue,
    Input,
    RadioButton,
} from "client/components"

import {
    ModelNestedWrapper,
    SettingsWrapper,
    SettingsTitle,
} from "client/pages/sil/modelStyled"

import FormatPercentage from "client/pages/sil/format/percentage"

const Settings = () => {
    const safetyFunction = useSelector((state: StoreType) => state.silSafetyFunction.safetyFunctionView)
    const lang = useSelector((state: StoreType) => state.system.lang)

    // important! get the subsystem list from the function!
    const subsystemList = safetyFunction.subsystems || []

    // calculation method can be or dangerous or safe or "no dangerous/safe failure", never both
    const { calculationMethodDangerous, calculationMethodSafe } = safetyFunction
    let calculationMethod: SilCalculationMethod = null
    if (calculationMethodDangerous !== NO_DANGEROUS_FAILURE) calculationMethod = calculationMethodDangerous
    if (calculationMethodSafe !== NO_SAFE_FAILURE) calculationMethod = calculationMethodSafe

    return (
        <ModelNestedWrapper>
            {
                subsystemList.map((subsystem) => {
                    const { architecture } = subsystem
                    const constraints = subsystem.architecturalConstraints
                    let constraintsTitle = ""
                    if (constraints === NO_ARCHITECTURAL_CONSTRAINTS) constraintsTitle = lang.noArchitecturalConstraints
                    if (constraints === IEC_61508_2010) constraintsTitle = lang.iec_61508_2010
                    if (constraints === IEC_61508_1998) constraintsTitle = lang.iec_61508_1998
                    if (constraints === IEC_61511_2016) constraintsTitle = lang.iec_61511_2016
                    if (constraints === IEC_61511_2003) constraintsTitle = lang.iec_61511_2003

                    let isatr842022tiShow = true
                    let isatr842022diShow = true
                    let isatr842022mttrShow = true
                    let isatr842022betaShow = true

                    if (calculationMethod === ISA_TR84_2022) {
                        // calculation method can be or dangerous or safe or "no dangerous/safe failure", never both
                        if (calculationMethodSafe === ISA_TR84_2022) {
                            if (
                                subsystem.architecture === ARCHITECTURE_1oo1
                                || subsystem.architecture === ARCHITECTURE_1oo2
                                || subsystem.architecture === ARCHITECTURE_1oo3
                            ) {
                                isatr842022tiShow = false
                                isatr842022mttrShow = false
                            }
                            isatr842022diShow = false
                            isatr842022betaShow = false
                        }

                        if (calculationMethodDangerous === ISA_TR84_2022) {
                            if (
                                subsystem.architecture === ARCHITECTURE_1oo1
                                || subsystem.architecture === ARCHITECTURE_2oo2
                                || subsystem.architecture === ARCHITECTURE_3oo3
                            ) {
                                isatr842022betaShow = false
                            }
                        }
                    }

                    return (
                        <SettingsWrapper key={subsystem.id} viewMode>
                            <SettingsTitle>{subsystem.name}</SettingsTitle>
                            {
                                calculationMethod === IEC_61508_2010 && (
                                    <div>
                                        <FormGroup>
                                            <Label>
                                                {lang.t1}
                                                <LabelValue>{lang.hoursLabel}</LabelValue>
                                            </Label>
                                            <Input type="text" value={subsystem.iec615082010t1 || ""} readOnly />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>
                                                {lang.mttr}
                                                <LabelValue>{lang.hoursLabel}</LabelValue>
                                            </Label>
                                            <Input type="text" value={subsystem.iec615082010mttr || ""} readOnly />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>
                                                {lang.mrt}
                                                <LabelValue>{lang.hoursLabel}</LabelValue>
                                            </Label>
                                            <Input type="text" value={subsystem.iec615082010mrt || ""} readOnly />
                                        </FormGroup>

                                        {
                                            (
                                                architecture === ARCHITECTURE_1oo2
                                                || architecture === ARCHITECTURE_1oo2D
                                                || architecture === ARCHITECTURE_1oo3
                                                || architecture === ARCHITECTURE_2oo3
                                            ) && (
                                                <FormatPercentage
                                                    title={lang.beta}
                                                    data={subsystem.iec615082010beta}
                                                    inputView
                                                />
                                            )
                                        }
                                        {
                                            (
                                                architecture === ARCHITECTURE_1oo2
                                                || architecture === ARCHITECTURE_1oo2D
                                                || architecture === ARCHITECTURE_1oo3
                                                || architecture === ARCHITECTURE_2oo3
                                            ) && (
                                                <FormatPercentage
                                                    title={lang.betaD}
                                                    data={subsystem.iec615082010betaD}
                                                    inputView
                                                />
                                            )
                                        }
                                        {
                                            architecture === ARCHITECTURE_1oo2D && (
                                                <FormatPercentage
                                                    title={lang.k}
                                                    data={subsystem.iec615082010k}
                                                    inputView
                                                />
                                            )
                                        }
                                    </div>
                                )
                            }
                            {
                                calculationMethod === IEC_61508_1998 && (
                                    <div>
                                        <FormGroup>
                                            <Label>
                                                {lang.t1}
                                                <LabelValue>{lang.hoursLabel}</LabelValue>
                                            </Label>
                                            <Input type="text" value={subsystem.iec615081998t1 || ""} readOnly />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>
                                                {lang.mttr}
                                                <LabelValue>{lang.hoursLabel}</LabelValue>
                                            </Label>
                                            <Input type="text" value={subsystem.iec615081998mttr || ""} readOnly />
                                        </FormGroup>

                                        {
                                            (
                                                architecture === ARCHITECTURE_1oo2
                                                || architecture === ARCHITECTURE_1oo2D
                                                || architecture === ARCHITECTURE_2oo3
                                            ) && (
                                                <FormatPercentage
                                                    title={lang.beta}
                                                    data={subsystem.iec615081998beta}
                                                    inputView
                                                />
                                            )
                                        }
                                    </div>
                                )
                            }
                            {
                                calculationMethod === ISA_TR84_2002 && (
                                    <div>
                                        <FormGroup>
                                            <Label>
                                                {lang.t1}
                                                <LabelValue>{lang.hoursLabel}</LabelValue>
                                            </Label>
                                            <Input type="text" value={subsystem.tr842002t1 || ""} readOnly />
                                        </FormGroup>
                                        {
                                            architecture !== ARCHITECTURE_1oo1 && (
                                                <FormGroup>
                                                    <Label>
                                                        {lang.mttr}
                                                        <LabelValue>{lang.hoursLabel}</LabelValue>
                                                    </Label>
                                                    <Input type="text" value={subsystem.tr842002mttr || ""} readOnly />
                                                </FormGroup>
                                            )
                                        }
                                        {
                                            architecture !== ARCHITECTURE_1oo1 && (
                                                <FormatPercentage
                                                    title={lang.beta}
                                                    data={subsystem.tr842002beta}
                                                    inputView
                                                />
                                            )
                                        }
                                        <FormatPercentage
                                            title={lang.safeSystematicFailure}
                                            data={subsystem.tr842002safeFailure}
                                            inputView
                                        />
                                        <FormatPercentage
                                            title={lang.dangerousSystematicFailure}
                                            data={subsystem.tr842002dangerousFailure}
                                            inputView
                                        />
                                    </div>
                                )
                            }
                            {
                                calculationMethod === ISA_TR84_2022 && (
                                    <div>
                                        {
                                            isatr842022tiShow && (
                                                <FormGroup>
                                                    <Label>
                                                        {lang.ti}
                                                        <LabelValue>{lang.hoursLabel}</LabelValue>
                                                    </Label>
                                                    <Input type="text" value={subsystem.isatr842022ti || ""} readOnly />
                                                </FormGroup>
                                            )
                                        }
                                        {
                                            isatr842022diShow && (
                                                <FormGroup>
                                                    <Label>
                                                        {lang.di}
                                                        <LabelValue>{lang.hoursLabel}</LabelValue>
                                                    </Label>
                                                    <Input type="text" value={subsystem.isatr842022di || ""} readOnly />
                                                </FormGroup>
                                            )
                                        }
                                        {
                                            isatr842022mttrShow && (
                                                <FormGroup>
                                                    <Label>
                                                        {lang.mttr}
                                                        <LabelValue>{lang.hoursLabel}</LabelValue>
                                                    </Label>
                                                    <Input type="text" value={subsystem.isatr842022mttr || ""} readOnly />
                                                </FormGroup>
                                            )
                                        }
                                        {
                                            isatr842022betaShow && (
                                                <FormatPercentage
                                                    title={lang.beta}
                                                    data={subsystem.isatr842022beta || ""}
                                                    inputView
                                                />
                                            )
                                        }
                                        <FormGroup>
                                            <Label>
                                                {calculationMethodSafe === ISA_TR84_2022 && lang.detectedFailuresLeadToSafeState}
                                                {calculationMethodDangerous === ISA_TR84_2022 && lang.detectedFailuresLeadToDangerousState}
                                            </Label>
                                            <FormGroup inline>
                                                <RadioButton
                                                    checked={subsystem.isatr842022safeState === YES}
                                                    title={lang.yes}
                                                    readOnly
                                                />
                                                <RadioButton
                                                    checked={subsystem.isatr842022safeState === NO}
                                                    title={lang.no}
                                                    readOnly
                                                />
                                            </FormGroup>
                                        </FormGroup>
                                    </div>
                                )
                            }
                            {
                                calculationMethod === VDI_VDE_2180_2019 && (
                                    <div>
                                        <FormatPercentage
                                            title={lang.ptc0A}
                                            data={subsystem.vdivde21802019ptc0A}
                                            inputView
                                        />
                                        <FormatPercentage
                                            title={lang.ptc1A}
                                            data={subsystem.vdivde21802019ptc1A}
                                            inputView
                                        />
                                        {
                                            (
                                                architecture === ARCHITECTURE_1oo2
                                                || architecture === ARCHITECTURE_1oo3
                                                || architecture === ARCHITECTURE_2oo2
                                                || architecture === ARCHITECTURE_2oo3
                                            ) && (
                                                <div>
                                                    <FormatPercentage
                                                        title={lang.ptc0B}
                                                        data={subsystem.vdivde21802019ptc0B}
                                                        inputView
                                                    />
                                                    <FormatPercentage
                                                        title={lang.ptc1B}
                                                        data={subsystem.vdivde21802019ptc1B}
                                                        inputView
                                                    />
                                                </div>
                                            )
                                        }
                                        {
                                            (
                                                architecture === ARCHITECTURE_1oo3
                                                || architecture === ARCHITECTURE_2oo3
                                            ) && (
                                                <div>
                                                    <FormatPercentage
                                                        title={lang.ptc0C}
                                                        data={subsystem.vdivde21802019ptc0C}
                                                        inputView
                                                    />
                                                    <FormatPercentage
                                                        title={lang.ptc1C}
                                                        data={subsystem.vdivde21802019ptc1C}
                                                        inputView
                                                    />
                                                </div>
                                            )
                                        }
                                        {
                                            (
                                                architecture === ARCHITECTURE_1oo2
                                                || architecture === ARCHITECTURE_1oo3
                                                || architecture === ARCHITECTURE_2oo3
                                            ) && (
                                                <FormatPercentage
                                                    title={lang.beta}
                                                    data={subsystem.vdivde21802019beta}
                                                    inputView
                                                />
                                            )
                                        }
                                        <FormGroup>
                                            <Label>
                                                {lang.t0}
                                                <LabelValue>{lang.hoursLabel}</LabelValue>
                                            </Label>
                                            <Input type="text" value={subsystem.vdivde21802019t0 || ""} readOnly />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>
                                                {lang.t1}
                                                <LabelValue>{lang.hoursLabel}</LabelValue>
                                            </Label>
                                            <Input type="text" value={subsystem.vdivde21802019t1 || ""} readOnly />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>
                                                {lang.t2}
                                                <LabelValue>{lang.hoursLabel}</LabelValue>
                                            </Label>
                                            <Input type="text" value={subsystem.vdivde21802019t2 || ""} readOnly />
                                        </FormGroup>
                                    </div>
                                )
                            }

                            {
                                calculationMethodDangerous !== NO_DANGEROUS_FAILURE && (
                                    // display only for dangerous method
                                    <FormGroup>
                                        <Label>{lang.architecturalConstraints}</Label>
                                        <Input
                                            type="text"
                                            value={constraintsTitle}
                                            readOnly
                                        />
                                    </FormGroup>
                                )
                            }
                        </SettingsWrapper>
                    )
                })
            }
        </ModelNestedWrapper>
    )
}
export default Settings
